import React, { useState } from 'react';
import ScheduleWarningsPopoverInner from './ScheduleWarningsPopoverInner';
import axios from 'axios';

// This version of the ScheduleWarningsPopover is used in combination with Rails
// requests. It allows redirecting to a specified URL on confirm
const ScheduleWarningsPopover = props => {
  const [show, setShow] = useState(true);

  const retryRequest = () => {
    // If a retry handler is supplied, use it
    if (props.retryHandler) {
      props.retryHandler();
      setShow(false);
      return;
    }

    // Otherwise, handle the retry internally using
    // the retryPath
    const retryPath = props.retryPath;
    return axios.get(retryPath).then(response => {
      setShow(false);

      const { data } = response;
      if (props.redirectPath) {
        if (props.redirectPathAppendId) {
          const objectId = data.id;
          globalThis.location = `${props.redirectPath}/${objectId}`;
        } else {
          globalThis.location = props.redirectPath;
        }
      } else {
        // support callbacks as string (global function on window) or as a
        // proper function
        if (typeof props.successCallback === 'string') {
          window[props.successCallback](data);
        } else if (typeof props.successCallback === 'function') {
          props.successCallback(data);
        }
      }
    });
  };

  if (!show) return null;

  return (
    <ScheduleWarningsPopoverInner
      warnings={props.warnings}
      handleDismiss={() => setShow(false)}
      handleConfirm={retryRequest}
    />
  );
};

export default ScheduleWarningsPopover;
